import { ReactNode } from 'react';

interface BladeSimpleSectionProps {
  title: ReactNode;
  children: ReactNode;
}

const BladeSimpleSection = ({ title, children }: BladeSimpleSectionProps) => {
  return (
    <div className="flex flex-col gap-2">
      <span className="body-lr-semibold text-(--font-sub-title)">{title}</span>
      {children}
    </div>
  );
};

export default BladeSimpleSection;

